import * as d3 from 'd3';
import { getIndicatorColor } from './colors';



export const drawBollingerBandsIndicator = (config) => {
    const { svg, data, xScale, yScale, indicators } = config;
    try {
        // The indicators object now contains already transformed data
        // No need to transform again, just use it directly
        const upperData = indicators.upper_band;
        const lowerData = indicators.lower_band;
        const middleData = indicators.middle_band;

        // D3 line generators for each band
        const bandLines = {
            upper: d3.line()
                .x(d => xScale(d.x))
                .y(d => (d.y !== null) ? yScale(d.y) : null)
                .curve(d3.curveMonotoneX),
            lower: d3.line()
                .x(d => xScale(d.x))
                .y(d => (d.y !== null) ? yScale(d.y) : null)
                .curve(d3.curveMonotoneX),
            middle: d3.line()
                .x(d => xScale(d.x))
                .y(d => (d.y !== null) ? yScale(d.y) : null)
                .curve(d3.curveMonotoneX)
        };

        // Draw each Bollinger Band path
        Object.entries(bandLines).forEach(([band, lineGen]) => {
            svg.append("path")
                .datum(band === "upper" ? upperData : band === "lower" ? lowerData : middleData)
                .attr("class", `bollinger-${band}-line`)
                .attr("fill", "none")
                .attr("stroke", getIndicatorColor("Bollinger-Bands"))
                .attr("stroke-width", 1.5)
                .attr("d", lineGen);
        });

    } catch (error) {
        console.warn("Error drawing Bollinger Bands:", error);
    }
};

export default drawBollingerBandsIndicator;